import {Box, Button, Grid, Icon, useTheme} from "@mui/material";
import {FORM_ITEMS_PROPS, GENERAL_OBJECT} from "@/components/types";
import {useTranslation} from "react-i18next";
import React, {useRef, useState} from "react";
import 'react-phone-input-2/lib/material.css';
import DOMPurify from "dompurify";
import Link from "next/link";
import LoadingButton from "@mui/lab/LoadingButton";

const button = {
    "& .material-icons": {
        fontSize: "0.8rem!important"
    }
}

export const SafeHtmlRenderer = ({errorItemsHelperText, helperText}: {
    errorItemsHelperText?: string;
    helperText?: string
}) => {
    const {t} = useTranslation("users");
    const sanitizedHtml = DOMPurify.sanitize(!!helperText ? helperText : !!errorItemsHelperText ? errorItemsHelperText : t("global:forms.thisFieldIsRequired"));
    return <div style={{fontSize: "0.8rem", color: "#EE204D", marginTop: "2px"}}
                dangerouslySetInnerHTML={{__html: sanitizedHtml}}/>
};

const isValidDate = (date: string | Date) => {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime());
};


const CustomForm = ({formItems, initialValues, onValidSubmit, cancelButton, loading}: FORM_ITEMS_PROPS) => {
    const {t} = useTranslation("users");
    const theme = useTheme();
    const [errorItems, setErrorItems] = useState<string[]>([]);
    const [errorItemsHelperText, setErrorItemsHelperText] = useState("")
    const [values, setValues] = useState<GENERAL_OBJECT>(initialValues ?? {});
    const fieldRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        if (!loading) {
            setValues({
                ...values,
                [e.target.name]: e.target.value
            });
            setErrorItems([]);
            setErrorItemsHelperText("");
        }
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        for (let item of formItems.items) {
            if (item.validation) {
                let isError = false, helperText = "";
                const value = values[item.name];
                const validationType = item.validateForType ?? item.type;
                if (!value) isError = true;
                else if (validationType === "email") {
                    isError = !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value as string))
                    helperText = t("invalidEmailFormat" as any)
                } else if (validationType === "date") {
                    if (!isValidDate(value)) {
                        isError = true;
                        helperText = t("invalidDateFormat" as any)
                    }
                } else if (item.min) {
                    if (validationType === "number") {
                        isError = Number(value) < item.min;
                        helperText = t("numberMustBeGreaterThan", {min: item.min})
                    }
                    if (validationType === "text") {
                        isError = value.length < item.min;
                        helperText = t("minimumNumberOfCharactersMustBe", {min: item.min})
                    }
                } else if (item.max) {
                    if (validationType === "number") {
                        isError = Number(value) > item.max;
                        helperText = t("numberMustBeLessThan", {max: item.max})
                    }
                    if (validationType === "text") {
                        isError = value.length > item.max;
                        helperText = t("maximumNumberOfCharactersMustBe", {max: item.max})
                    }
                }
                if (isError) {
                    setErrorItems([item.name!])
                    setErrorItemsHelperText(helperText)
                    fieldRefs.current[item.name]?.scrollIntoView({behavior: "smooth", block: "center"});
                    return;
                }
            }
        }
        onValidSubmit(values);
    }

    return <Grid className="df we1">
        <Box className="df we1 fdc" component="form" onSubmit={handleSubmit} sx={{
            "& .react-tel-input .form-control": {
                width: "100%",
                transition: "border-color 0.3s",
                "&:hover": {borderColor: `${theme.palette.primary.main} !important`}, // Hover (Primary Color)
                "&:focus": {borderColor: `${theme.palette.primary.main} !important`}, // Focus (Primary Color)
                "&.error": {borderColor: `${theme.palette.error.main} !important`}, // Error State
            },
        }}>
            {/*{formItems[0].items.map((item, index) => (*/}
            {/*    <Grid*/}
            {/*        className="df fdc we1"*/}
            {/*        key={`formItem-${item.name}`}*/}
            {/*        sx={{*/}
            {/*            mt: index > 0 ? 3 : 0,*/}
            {/*            "& .MuiInputBase-root": {*/}
            {/*                height: "2.8rem"*/}
            {/*            }*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <Typography*/}
            {/*            variant="subtitle2"*/}
            {/*            sx={{*/}
            {/*                ...(item.localLabelStyles ?? {}),*/}
            {/*                ...(formItems.globalLabelStyles ?? {})*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {item.label}*/}
            {/*        </Typography>*/}
            {/*        {["text", "number", "email"].includes(item.type) ?*/}
            {/*            <Grid className="df we1 fdc" ref={(el) => (fieldRefs.current[item.name] = el)}>*/}
            {/*                <TextField*/}
            {/*                    id={`text-${index}`}*/}
            {/*                    name={item.name}*/}
            {/*                    variant="outlined"*/}
            {/*                    value={values[item.name] ?? ""}*/}
            {/*                    onChange={handleChange}*/}
            {/*                    type={item.type}*/}
            {/*                    sx={{*/}
            {/*                        backgroundColor: "backgrounds.main",*/}
            {/*                        mt: 0.1,*/}
            {/*                        ...(formItems.globalStyles ?? {}), ...(item.localStyles ?? {})*/}
            {/*                    }}*/}
            {/*                />*/}
            {/*                {errorItems.includes(item.name) &&*/}
            {/*                    <SafeHtmlRenderer*/}
            {/*                        errorItemsHelperText={errorItemsHelperText}*/}
            {/*                        helperText={item.helperText}*/}
            {/*                    />}*/}
            {/*            </Grid> : item.type === "select" ? <Grid className="df we1 fdc">*/}
            {/*                <CustomSelect*/}
            {/*                    name={item.name}*/}
            {/*                    label={item.label}*/}
            {/*                    value={values[item.name]}*/}
            {/*                    onChange={handleChange}*/}
            {/*                    options={item.options}*/}
            {/*                />*/}
            {/*                {errorItems.includes(item.name) &&*/}
            {/*                    <SafeHtmlRenderer*/}
            {/*                        errorItemsHelperText={errorItemsHelperText}*/}
            {/*                        helperText={item.helperText}*/}
            {/*                    />}*/}
            {/*            </Grid> : item.type === "date" ? <Grid className="df we1 fdc">*/}
            {/*                <LocalizationProvider dateAdapter={AdapterDayjs}>*/}
            {/*                    <DatePicker*/}
            {/*                        sx={{*/}
            {/*                            backgroundColor: "backgrounds.main",*/}
            {/*                            mt: 0.1,*/}
            {/*                            ...(formItems.globalStyles ?? {}), ...(item.localStyles ?? {})*/}
            {/*                        }}*/}
            {/*                        value={values[item.name]}*/}
            {/*                        onChange={(newDate) => {*/}
            {/*                            if (!loading) {*/}
            {/*                                setValues({...values, [item.name]: newDate})*/}
            {/*                            }*/}
            {/*                        }}*/}
            {/*                    />*/}
            {/*                </LocalizationProvider>*/}
            {/*                {errorItems.includes(item.name) &&*/}
            {/*                    <SafeHtmlRenderer*/}
            {/*                        errorItemsHelperText={errorItemsHelperText}*/}
            {/*                        helperText={item.helperText}*/}
            {/*                    />}*/}
            {/*            </Grid> : item.type === "contact" ? <Grid className="df we1 fdc" sx={{*/}
            {/*                "& .myClass": {}*/}
            {/*            }}>*/}
            {/*                <PhoneInput*/}
            {/*                    inputClass={"myclass"}*/}
            {/*                    searchNotFound={t("noRecordFound")}*/}
            {/*                    countryCodeEditable={false}*/}
            {/*                    enableSearch={true}*/}
            {/*                    onlyCountries={item.countries ?? ['pk']}*/}
            {/*                    specialLabel=""*/}
            {/*                    placeholder={item.placeHolder ?? t("enterPhoneNumber")}*/}
            {/*                    country={item.defualtCountry ?? 'pk'}*/}
            {/*                    value={values[item.name] ?? ""}*/}
            {/*                    onChange={phone => {*/}
            {/*                        if (!loading) {*/}
            {/*                            setValues({...values, [item.name]: phone})*/}
            {/*                            setErrorItems([]);*/}
            {/*                            setErrorItemsHelperText("");*/}
            {/*                        }*/}
            {/*                    }}*/}
            {/*                    containerStyle={{width: "100%"}}*/}
            {/*                    inputStyle={{*/}
            {/*                        width: "100%",*/}
            {/*                        height: "2.8rem",*/}
            {/*                        backgroundColor: theme.palette?.backgrounds?.main,*/}
            {/*                        color: theme.palette?.text?.primary,*/}
            {/*                        border: `1px solid ${theme.palette?.borders?.contactInput}`*/}
            {/*                    }}*/}
            {/*                />*/}
            {/*                {errorItems.includes(item.name) &&*/}
            {/*                    <SafeHtmlRenderer*/}
            {/*                        errorItemsHelperText={errorItemsHelperText}*/}
            {/*                        helperText={item.helperText}*/}
            {/*                    />}*/}
            {/*            </Grid> : null}*/}
            {/*    </Grid>*/}
            {/*))}*/}
            <Grid className="df we1 jce" sx={{mt: 2}}>
                {!!cancelButton && <Grid sx={{p: 0.5}}>
                    {/*@ts-ignore*/}
                    <Button
                        startIcon={!cancelButton?.icon ? null : <Icon>{cancelButton.icon}</Icon>}
                        disabled={loading}
                        sx={{width: "8rem", ...button}}
                        variant="contained"
                        component={!cancelButton?.link ? null : Link}
                        href={!cancelButton?.link ? null : cancelButton.link}
                        onClick={!cancelButton?.onClick ? null : cancelButton.onClick}
                    >{cancelButton?.label ?? t("global:cancel")}</Button>
                </Grid>}
                <Grid sx={{p: 0.5}}>
                    <LoadingButton
                        loading={loading}
                        sx={{width: "8rem"}}
                        variant="contained"
                        type="submit"
                    >{t("global:submit")}</LoadingButton>
                </Grid>
            </Grid>
        </Box>
    </Grid>
}

export default CustomForm;